import { Injectable } from '@angular/core';
import {
  HttpErrorResponse, HttpEvent, HttpHandler,
  HttpInterceptor, HttpRequest,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { AuthService } from '../auth.service';
import { catchError } from 'rxjs/operators';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(private auth: AuthService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    request = request.clone({
      setHeaders: {
        'x-access-token': `${this.auth.getToken()}`
      }
    });
    // it should work only for admin part!
    return next.handle(request)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          if (error.status === 401) {
            console.error('401');
            // redirect to login page
            this.auth.logout();
            // this.router.navigate(['login']);
          }
          if (error.status === 403) {
            console.log('ACCESS IS FORBIDDEN');
            // this.router.navigate(['manage/page/forbidden']);
          }
          return throwError(error);
        })
      );
  }
}
